define(function(require,exports,module){
	var ReString = require( './string' );
	var BASE10=10;

	return {
	    removeNode : function(parent,child){

            if(child===undefined){
                child=parent;
                parent=child && child.parentNode;
            }
            if(parent && child && child.parentNode===parent){
                parent.removeChild(child);
                    // Return incase the caller would like to store the
                    // old child.
                return child;
            }

	    	return this;
	    },
	    removeStyleProperty : function(el,attr){
	    	if(el && el.style && attr){
	    	/* IE doesn't support remove property, so do this first */
	    		el.style[attr]='';
	    		el.style.removeProperty(attr);
	    	}
	    	return this;
	    },

		cssValAsNumber : function(cssVal) {
			if(isNaN(cssVal)) {
				if(cssVal==="auto" || cssVal==="inherit") {
					return 1;
				}

				if(cssVal.indexOf("%") > -1) {
					return 10000;
				}
				if(cssVal.toLowerCase().indexOf("px") !== -1) {
					return parseFloat(cssVal,BASE10);
				}

			}
			return cssVal;
		},
		createStyleNode : function(opts,node){
				var style=node||document.createElement('style'),
					css=opts.css||'';

			style.type=opts.type||"text/css";
			style.media=opts.media||"all";
			if(style.styleSheet){
				style.styleSheet.cssText=css;
			}else if(style.innerHTML){
				style.innerHTML=css;
			}else{
				style.appendChild(document.createTextNode(css))
			}
			return style;
		},
		
		isBoundByParent : function (_view) {
			var view= _view && _view.isViewLoaded() && _view.getView(),
		  		parent= view && _view.parentViewController && 
		  			_view.parentViewController.isViewLoaded() && _view.parentViewController.getView(),
		  		bounds, port, center;

		  if(!view){
		  	return false;
		  }
		  if(!!!parent && _view && view){
		  	return !!_view.rootView;
		  }

		  bounds=view.getBoundingClientRect();
		  port=parent.getBoundingClientRect();
		  center=(bounds.left + bounds.width/2);

		  return center > port.left && center < port.right;
		},
		scrollToTop :function(view,top){
			var op=window.scrollY;
			view.scrollIntoView(!top,0);
			return function(){
				window.scrollTo(op,0);
			}
		},
        setClassName : function(view, className, replace){
            var $view = $(view);
            if(className){
                $view.addClass(className);
            }
            if(replace && replace !== className){
                $view.removeClass(replace);
            }
            return this;
        },
        removeClassName : function(view, className){
            if(className){
            	$(view).removeClass(className);
            }
        },
	}
});